<template>
  <div class="auth-layout">
    <div class="auth-form-container">
      <router-link to="login"> </router-link>
      <div class="form-wrapper">
        <slot />
      </div>
      <ProgressSteps
        v-if="manySteps"
        :count="stepsCount"
        :current="currentStep"
        class="auth-steps"
      />
      <TermsAndPolicy :is-login="isLogin" class="auth-terms" />
    </div>
    <div class="auth-illustration-wrapper flex-centering">
      <div class="auth-illustration-container">
        <!--        <img src="/images/auth-illustration.jpeg" alt="Interface" class="auth-illustration" />-->
        <div class="auth-illustration-description">
          <div class="auth-illustration-title">
            {{ $t('Automate your construction tenders and save up to 5% of your budget') }}
          </div>
          <div class="auth-illustration-text">
            {{
              $t(
                `replaces the endless emails and Excel sheets, thanks to the procurement processes automation and construction's adopted spreadsheets`
              )
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TermsAndPolicy from '@/components/common/TermsAndPolicy';
  import ProgressSteps from '@/components/ui/ProgressSteps';

  export default {
    name: 'AuthLayout',
    components: { ProgressSteps, TermsAndPolicy },
    props: {
      manySteps: {
        type: Boolean,
        default: false,
      },
      isLogin: {
        type: Boolean,
        default: false,
      },
      currentStep: {
        type: Number,
        default: 1,
      },
      stepsCount: {
        type: Number,
        default: 3,
      },
    },
  };
</script>
<style lang="scss">
  @import 'src/styles/pages/auth-page';
</style>
